/* returns routes and router configuration for the specific root route 
    1. Only ROOT and Parenst Routes will be their
*/

import { IRouteChildren, IRouteDefined, IRoutesDefined, RouteKeys } from "@/api_framework/api_modals/Routers";
import {
  APPOINTMENTS_CHECK_SLOTS_SUB_ROUTES,
  APPOINTMENTS_SUB_NAVIGATION_ROUTES,
  CONFIGURATION_SUB_NAVIGATION_ROUTES,
  CUSTOMER_DETAILS_ACTION_ROUTES,
  CUSTOMER_DETAILS_TABS,
  CUSTOMER_PROFILE_SUB_NAVIGATION_ROUTES,
  INVENTORY_SUB_NAVIGATION_ROUTES,
  ACCOUNTING_SUB_NAVIGATION_ROUTES,
  DAY_CLOSING_SUB_NAVIGATION_ROUTES,
  NAVIGATION_ROUTES,
  ORDER_SUB_NAVIGATION_ROUTES,
  ROTA_SUB_NAVIGATION_ROUTES,
  ROUTES,
  SERVICE_DESK_SUB_NAVIGATION_ROUTES,
  SLOTS_SUB_NAVIGATION_ROUTES,
  CART_MANAGEMENT_SUB_NAV_ROUTES,
  SLOTS_TABS,
  COUPON_SERVICE_SUB_NAVIGATION_ROUTES,
  MEMBERSHIP_SETUP_SUB_NAVIGATION_ROUTES,
  MEMBERSHIP_EXTENSION_SUB_NAVIGATION_ROUTES,
  VOUCHER_SETUP_SUB_NAVIGATION_ROUTES,
  GIFT_SETUP_SUB_NAVIGATION_ROUTES,
  WHITELIST_MOBILE_SUB_NAV_ROUTES,
  LAB_REPORT_SUB_NAVIGATION_ROUTES,
  CLINIC_LAB_REPORT_SUB_NAVIGATION_ROUTES,
  LAB_REPORT_INTERPRETATION_SUB_NAVIGATION_ROUTES,
  DATA_MAPPINGS_SUB_NAV_ROUTES,
  TILES_PAGE_SUB_NAV_ROUTES,
} from "../routes";

// type useRouterReturnType =

export const useRouter = () => {
  const expandedSearch = (router: IRoutesDefined, route: RouteKeys): IRouteDefined | null => {
    const routeDetails: string = Object.keys(router).find((r) => r === route);
    if (routeDetails) {
      return router[route];
    } else {
      return null;
    }
  };
  // private method
  const fetchRouteDetails = (route: RouteKeys): IRouteDefined => {
    const result =
      expandedSearch(ROUTES, route) ??
      expandedSearch(SLOTS_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(CUSTOMER_DETAILS_ACTION_ROUTES, route) ??
      expandedSearch(CUSTOMER_DETAILS_TABS, route) ??
      expandedSearch(CUSTOMER_PROFILE_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(NAVIGATION_ROUTES, route) ??
      expandedSearch(APPOINTMENTS_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(SLOTS_TABS, route) ??
      expandedSearch(CONFIGURATION_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(ORDER_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(ROTA_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(APPOINTMENTS_CHECK_SLOTS_SUB_ROUTES, route) ??
      expandedSearch(INVENTORY_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(ACCOUNTING_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(DAY_CLOSING_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(SERVICE_DESK_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(CART_MANAGEMENT_SUB_NAV_ROUTES, route) ??
      expandedSearch(COUPON_SERVICE_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(MEMBERSHIP_SETUP_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(MEMBERSHIP_EXTENSION_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(VOUCHER_SETUP_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(GIFT_SETUP_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(WHITELIST_MOBILE_SUB_NAV_ROUTES, route) ??
      expandedSearch(CLINIC_LAB_REPORT_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(LAB_REPORT_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(LAB_REPORT_INTERPRETATION_SUB_NAVIGATION_ROUTES, route) ??
      expandedSearch(DATA_MAPPINGS_SUB_NAV_ROUTES, route) ??
      expandedSearch(TILES_PAGE_SUB_NAV_ROUTES, route);
    return result;
  };

  const getRouteDetails = (route: RouteKeys): IRouteDefined => {
    return fetchRouteDetails(route);
  };

  const getRouteKey = (route: RouteKeys, key: keyof IRouteDefined): string => {
    if (key === "children") {
      throw "Please use getRouteChildrens(route,key) method to get childrens";
    }
    const details: any = fetchRouteDetails(route);
    if (!details) {
      // A missing route registration should not white-screen the whole app.
      console.error(`useRouter.getRouteKey: no route definition found for "${route}"`);
      return "";
    }
    return details[key];
  };

  const getRouteChildrens = (route: RouteKeys): IRouteChildren => {
    const details = fetchRouteDetails(route);
    if (!details) {
      console.error(`useRouter.getRouteChildrens: no route definition found for "${route}"`);
      return {} as IRouteChildren;
    }
    return details.children;
  };

  return { getRouteDetails, getRouteKey, getRouteChildrens };
};
